<ng-snotify [ngClass]="style"></ng-snotify>